(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-section-scr-system"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("ContactForm");
  if (!form) return;

  let isSubmitting = false;

  form.addEventListener("submit", function () {

    // Prevent duplicate sends
    if (isSubmitting) return;
    isSubmitting = true;

    const submitBtn = form.querySelector('input[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;


    /*
     * ==========================================
     * GET ATTRIBUTION DATA FROM LOCAL STORAGE
     * ==========================================
     */

    let attribution = {};

    try {
      attribution = typeof window.getMasterAireAttribution === "function"
        ? window.getMasterAireAttribution()
        : JSON.parse(localStorage.getItem("masteraire_attribution") || "{}");
    } catch (error) {
      console.error(
        "Could not read attribution data from localStorage:",
        error
      );

      attribution = {};
    }


    /*
     * ==========================================
     * CONTACT FORM + ATTRIBUTION DATA
     * ==========================================
     */

    const data = {

      // =========================
      // CONTACT INFORMATION
      // =========================

      name:
        document.getElementById("ContactForm-name")?.value || "",

      email:
        document.getElementById("ContactForm-email")?.value || "",

      phone:
        document.getElementById("ContactForm-phone")?.value || "",

      message:
        document.getElementById("ContactForm-message")?.value || "",


      // =========================
      // ATTRIBUTION DATA
      // =========================

      utm_source:
        attribution.utm_source || "",

      utm_medium:
        attribution.utm_medium || "",

      utm_campaign:
        attribution.utm_campaign || "",

      utm_term:
        attribution.utm_term || "",

      utm_content:
        attribution.utm_content || "",

      ad_group:
        attribution.ad_group || "",


      // =========================
      // AD CLICK IDs
      // =========================

      gclid:
        attribution.gclid || "",

      gbraid:
        attribution.gbraid || "",

      wbraid:
        attribution.wbraid || "",

      msclkid:
        attribution.msclkid || "",

      fbclid: attribution.fbclid || "",
      utm_id: attribution.utm_id || "",


      // =========================
      // ORIGINAL VISIT DATA
      // =========================

      original_landing_page:
        attribution.original_landing_page || "",

      referrer:
        attribution.referrer || "",

      attribution_timestamp:
        attribution.attribution_timestamp || "",


      // =========================
      // CURRENT PAGE
      // =========================

      page_url:
        window.location.href

    };


    /*
     * ==========================================
     * SEND TO N8N
     * ==========================================
     */

    fetch(
      "https://masteraire.app.n8n.cloud/webhook/masteraire-contactus",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify(data)
      }
    )
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          "n8n webhook returned status " +
          response.status
        );
      }

      console.log(
        "Contact form + attribution data sent successfully."
      );

    })
    .catch(function (err) {

      console.error(
        "n8n webhook error:",
        err
      );

    });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-section-second"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("ContactForm");
  if (!form) return;

  let isSubmitting = false;

  form.addEventListener("submit", function () {

    // Prevent duplicate sends
    if (isSubmitting) return;
    isSubmitting = true;

    const submitBtn = form.querySelector('input[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;


    /*
     * ==========================================
     * GET ATTRIBUTION DATA FROM LOCAL STORAGE
     * ==========================================
     */

    let attribution = {};

    try {
      attribution = typeof window.getMasterAireAttribution === "function"
        ? window.getMasterAireAttribution()
        : JSON.parse(localStorage.getItem("masteraire_attribution") || "{}");
    } catch (error) {
      console.error(
        "Could not read attribution data from localStorage:",
        error
      );

      attribution = {};
    }


    /*
     * ==========================================
     * CONTACT FORM + ATTRIBUTION DATA
     * ==========================================
     */

    const data = {

      // =========================
      // CONTACT INFORMATION
      // =========================

      name:
        document.getElementById("ContactForm-name")?.value || "",

      email:
        document.getElementById("ContactForm-email")?.value || "",

      phone:
        document.getElementById("ContactForm-phone")?.value || "",

      message:
        document.getElementById("ContactForm-message")?.value || "",


      // =========================
      // ATTRIBUTION DATA
      // =========================

      utm_source:
        attribution.utm_source || "",

      utm_medium:
        attribution.utm_medium || "",

      utm_campaign:
        attribution.utm_campaign || "",

      utm_term:
        attribution.utm_term || "",

      utm_content:
        attribution.utm_content || "",

      ad_group:
        attribution.ad_group || "",


      // =========================
      // AD CLICK IDs
      // =========================

      gclid:
        attribution.gclid || "",

      gbraid:
        attribution.gbraid || "",

      wbraid:
        attribution.wbraid || "",

      msclkid:
        attribution.msclkid || "",

      fbclid: attribution.fbclid || "",
      utm_id: attribution.utm_id || "",


      // =========================
      // ORIGINAL VISIT DATA
      // =========================

      original_landing_page:
        attribution.original_landing_page || "",

      referrer:
        attribution.referrer || "",

      attribution_timestamp:
        attribution.attribution_timestamp || "",


      // =========================
      // CURRENT PAGE
      // =========================

      page_url:
        window.location.href

    };


    /*
     * ==========================================
     * SEND TO N8N
     * ==========================================
     */

    fetch(
      "https://masteraire.app.n8n.cloud/webhook/masteraire-contactus",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify(data)
      }
    )
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          "n8n webhook returned status " +
          response.status
        );
      }

      console.log(
        "Contact form + attribution data sent successfully."
      );

    })
    .catch(function (err) {

      console.error(
        "n8n webhook error:",
        err
      );

    });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("ContactForm");
  if (!form) return;

  let isSubmitting = false;

  form.addEventListener("submit", function () {

    // Prevent duplicate sends
    if (isSubmitting) return;
    isSubmitting = true;

    const submitBtn = form.querySelector('input[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;


    /*
     * ==========================================
     * GET ATTRIBUTION DATA FROM LOCAL STORAGE
     * ==========================================
     */

    let attribution = {};

    try {
      attribution = typeof window.getMasterAireAttribution === "function"
        ? window.getMasterAireAttribution()
        : JSON.parse(localStorage.getItem("masteraire_attribution") || "{}");
    } catch (error) {
      console.error(
        "Could not read attribution data from localStorage:",
        error
      );

      attribution = {};
    }


    /*
     * ==========================================
     * CONTACT FORM + ATTRIBUTION DATA
     * ==========================================
     */

    const data = {

      // =========================
      // CONTACT INFORMATION
      // =========================

      name:
        document.getElementById("ContactForm-name")?.value || "",

      email:
        document.getElementById("ContactForm-email")?.value || "",

      phone:
        document.getElementById("ContactForm-phone")?.value || "",

      message:
        document.getElementById("ContactForm-message")?.value || "",


      // =========================
      // ATTRIBUTION DATA
      // =========================

      utm_source:
        attribution.utm_source || "",

      utm_medium:
        attribution.utm_medium || "",

      utm_campaign:
        attribution.utm_campaign || "",

      utm_term:
        attribution.utm_term || "",

      utm_content:
        attribution.utm_content || "",

      ad_group:
        attribution.ad_group || "",


      // =========================
      // AD CLICK IDs
      // =========================

      gclid:
        attribution.gclid || "",

      gbraid:
        attribution.gbraid || "",

      wbraid:
        attribution.wbraid || "",

      msclkid:
        attribution.msclkid || "",

      fbclid: attribution.fbclid || "",
      utm_id: attribution.utm_id || "",


      // =========================
      // ORIGINAL VISIT DATA
      // =========================

      original_landing_page:
        attribution.original_landing_page || "",

      referrer:
        attribution.referrer || "",

      attribution_timestamp:
        attribution.attribution_timestamp || "",


      // =========================
      // CURRENT PAGE
      // =========================

      page_url:
        window.location.href

    };


    /*
     * ==========================================
     * SEND TO N8N
     * ==========================================
     */

    fetch(
      "https://masteraire.app.n8n.cloud/webhook/masteraire-contactus",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json"
        },

        body: JSON.stringify(data)
      }
    )
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          "n8n webhook returned status " +
          response.status
        );
      }

      console.log(
        "Contact form + attribution data sent successfully."
      );

    })
    .catch(function (err) {

      console.error(
        "n8n webhook error:",
        err
      );

    });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scr-system-five-column-section"] && !Shopify.designMode) return;
  try {
    
/* Add your JS here if needed */

  } catch(e) { console.error(e); }
})();
})();
